function addUpsell(upsellID) {
    const items=[{
      id:upsellID,
      quantity: 1
    }]
    const formData = {
      items
    }
  	document.getElementById("upsell-product--container").style.display = "none";
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(()=>{
    ajaxCart.load()
  })
  .catch((error) => {
    ajaxCart.load()
    console.error('Error:', error);
  });
}
function addUpsellToCart(upsellID) {
  	document.getElementById("upsell-product--container").style.display = "none";
    jQuery.post('/cart/add.js', {
      quantity: 1,
      id: upsellID,
      processData: false,
      contentType: false,
      dataType: 'json',
      properties: {},
      success: function(line_item) {
        $.ajax({
			type: 'GET',
			url: '/cart.js',
			cache: true,
			dataType: 'json',
			success: function(cart) {
              console.log("added2")
        location.reload(true);
      }
		});
        
      }
    });
}
function cartupsell(upsellID) {
  $("#cartupsell-products-block").slideToggle();
  jQuery.post('/cart/add.js', {
    quantity: 1,
    id: upsellID,
    processData: false,
    contentType: false,
    dataType: 'json',
    success: function(line_item) {
      console.log("added 3")
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: true,
        dataType: 'json',
        success: function(cart) {}
      });

    }
  });
}